import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, NgZone } from '@angular/core';
import { ApiService } from "../../core/services/api.service";
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HeaderService } from 'src/app/core/services/header.service';
import { AudioService } from 'src/app/core/services/audio.service';
import { UserService } from 'src/app/core/services/user.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'; 
import '../../../assets/js/videojs-playlist.es.js';
import '../../../assets/js/videojs-playlist-ui.es.js';
import { PlayerService } from 'src/app/core/services/player.service';
import * as CryptoJS from 'crypto-js';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';

declare var $: any;
@Component({
  selector: 'app-search-group',
  templateUrl: './search-group.component.html',
  styleUrls: ['./search-group.component.scss']
})

export class SearchGroupComponent implements OnInit {
  @ViewChild('chatContainer') private chatContainer: ElementRef;
  loader: boolean = false;
  page_loader: boolean = false; 
  error: any = {}; 
  recognition: any;

  groups: {key: string, questions: any[]}[] = [];
  activeGroup: string | null = null;
  activeQuestion: number | null = null;



  constructor(private apiService: ApiService, private authService: AuthService, private router: Router,
    private http: HttpClient, private headerService: HeaderService, private ngZone: NgZone,
    private audioService: AudioService, private userService: UserService, private sanitizer: DomSanitizer,
    private playerService: PlayerService, private toasterService: ToastrService,) {  
  }

  toggleGroup(groupKey: string): void {
    this.activeGroup = this.activeGroup === groupKey ? null : groupKey;
    this.activeQuestion = null; // Reset active question when changing groups
  }

  toggleQuestion(questionId: number): void {
    this.activeQuestion = this.activeQuestion === questionId ? null : questionId;
  }

  getActiveGroupQuestions(): any[] {
    if (!this.activeGroup) return [];
    const group = this.groups.find(g => g.key === this.activeGroup);
    return group ? group.questions : [];
  }
  
  getGroup = () => { 
    this.apiService
      .callGetAPI("v2/group-question-answer-xref", environment.userApiUrl)
      .subscribe(
       (response) => { 
  // Transform the API response to match our expected format
  this.groups = Object.keys(response['response']).map(key => ({
    key: key,
    questions: response['response'][key] // Access the nested response data
  }));
  console.log("Groups loaded:", this.groups);
},
        (error) => {
          this.apiService.failureResponse(error, true);
          console.error("Error loading groups:", error);
        }
      );
  }

  ngOnInit() {
    this.getGroup()
  }

  

}
